<div class="h-full w-full">
    @if (dashboardsNotFound) {
        <div class="not-found-message">No dashboards found.</div>
    } @else if (dashboards.length > 0) {
        <p-tabView class="w-full">
            @for (dashboard of dashboards; track dashboard) {
                <p-tabPanel [header]="dashboard.title" headerStyleClass="w-full">
                    <ng-template pTemplate="content">
                        <iframe
                            width="100%"
                            height="600px"
                            frameborder="0"
                            title="metabase"
                            allowtransparency
                            [src]="dashboard.content"
                        ></iframe>
                    </ng-template>
                </p-tabPanel>
            }
        </p-tabView>
    } @else {
        <div class="loading-message">Loading dashboards...</div>
    }
</div>
